import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import useStyles from '../StatusSelect/styles';
import CustomTextField from '../CustomTextField/CustomTextField';

type Props = {
  customTextField?: boolean
  hubTypes?: string[]
} & TextFieldProps;

const HubTypeSelect: React.FC<Props> = props => {
  const defaultHubTypes = [
    { hubName: 'Ezlo Secure' },
    { hubName: 'Ezlo Wifi' },
    { hubName: 'Peplink' },
    { hubName: 'ADC' },
    { hubName: 'Kwikset'},
    { hubName: 'Seam'},
    { hubName: 'Schlage'}
  ];
  const { customTextField, hubTypes, ...restProps } = props;
  const availableHubTypes = hubTypes?.length
    ? hubTypes.map(hubName => ({ hubName }))
    : defaultHubTypes;

  const renderStatesItems = () => availableHubTypes.map(({ hubName }) => (
    <MenuItem
      key={hubName}
      value={hubName}
    >
      {hubName}
    </MenuItem>
  ));
  const classes = useStyles();
  return (
    <>
      { customTextField && (
        <>
          <CustomTextField
            margin="normal"
            fullWidth
            {...restProps}
            select
            inputProps={{
              classes: {
                disabled: classes.disabled,
              },
            }}
          >
            <MenuItem disabled value={1}>N / A</MenuItem>
            {renderStatesItems()}
          </CustomTextField>
        </>
      )
}
      { !customTextField && (
        <>
          <TextField
            margin="normal"
            fullWidth
            {...restProps}
            select
            inputProps={{
              classes: {
                disabled: classes.disabled,
              },
            }}
          >
            <MenuItem disabled value={1}>N / A</MenuItem>
            {renderStatesItems()}
          </TextField>
        </>
      )
  }
    </>
  );
};

export default React.memo(HubTypeSelect);
